// extracted by mini-css-extract-plugin
export var container = "Waste-module--container--loVOW";
export var content = "Waste-module--content--rvQ8l";
export var dateField = "Waste-module--dateField--KR-B9";
export var datePicker = "Waste-module--datePicker--qKemu";
export var noOrders = "Waste-module--noOrders--Z8bGD";
export var productSelect = "Waste-module--productSelect--kfYLc";
export var subHeader = "Waste-module--subHeader--bOF0y";